import strictCompiledSchema from "../__generated__/compiled_schema_strict.js";
import nonStrictCompiledSchema from "../__generated__/compiled_schema_non_strict.js";
export const getSchema = (key, mode = "strict") => {
    const schema = mode === "strict"
        ? strictCompiledSchema[key]
        : nonStrictCompiledSchema[key];
    if (!schema)
        throw new Error(`Could not find ${key} schema`);
    return schema;
};
